import { createSlice } from "@reduxjs/toolkit";

interface AdminState {
    isProfilesLoading: boolean;
};

const initialState: AdminState = {
    isProfilesLoading: false,
};

const adminSlice = createSlice({
    name: 'admin',
    initialState,
    reducers: {
        setProfileLoading(state, action) {
            state.isProfilesLoading = action.payload;
        },
    },
});
export default adminSlice.reducer;
export const { setProfileLoading } = adminSlice.actions;